export default {
    breadcrumbs: {
        home: 'Home',
        manage_account: 'Manage personal account',
    },
    heading: {
        verification: 'Verification',
        licences: 'Your licences',
        availability: 'Availability',
        medical_schools: 'Medical school (optional)',
        affiliated_hospitals: 'Affiliated hospital (optional)',
        residencies: 'Residency (optional)',
        fellowships: 'Fellowship (optional)',
        short_biography: 'About yourself (optional)',
        specialities: 'Specialities',
    },
    buttons: {
        primary: 'Save',
        secondary: 'Cancel',
    },
    availability: {
        see: 'See Availability',
        check: 'Check Availability',
        choose: 'Choose Location',
        pick_date: 'Select Date',
        date_selected: 'Date Selected:',
        not_set: 'Availability not set',
    },
    tabs: {
        account: 'Account Information',
        professional: 'Professional Information',
    },
}
